import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  FaSearch, 
FaRocket, FaAward, FaHeart, 
  FaComment, FaShare, FaBookmark,
  FaCamera, FaVideo, FaPoll, FaLink, 
  FaBell, FaUser,  FaGlobe, FaHandshake,
  FaNewspaper,   FaFlag,FaCheckCircle, FaUserGraduate, FaLightbulb, FaBrain, FaNetworkWired, FaChartLine, FaArrowRight
} from 'react-icons/fa';

// Enhanced mock data for alumni posts
const alumniPosts = [
  {
    id: 1,
    author: {
      name: "Dr. Priya Sharma",
      avatar: "https://i.pravatar.cc/150?img=1",
      company: "Google DeepMind",
      role: "Principal AI Research Scientist",
      graduationYear: 2015,
      degree: "Ph.D. in Computer Science",
      verified: true
    },
    content: "Thrilled to announce our groundbreaking paper on 'Quantum-Inspired Neural Networks for Climate Modeling' has been accepted at NeurIPS 2024! This work has the potential to revolutionize how we predict and mitigate climate change. Proud of our diverse, international team! 🌍🧠🌡️ #AI #ClimateAction #QuantumComputing",
    image: "https://picsum.photos/seed/ai1/800/600",
    timestamp: "2 hours ago",
    likes: 3520,
    comments: 289,
    shares: 1468,
    type: 'achievement',
    tags: ['#AI', '#ClimateChange', '#QuantumComputing', '#Research'],
    engagement: {
      topComment: {
        author: "Elon Musk",
        content: "Fascinating work! Would love to discuss potential applications at Tesla."
      }
    }
  },
  {
    id: 2,
    author: {
      name: "Arjun Patel",
      avatar: "https://i.pravatar.cc/150?img=2",
      company: "GreenTech Solutions",
      role: "Founder & CEO",
      graduationYear: 2012,
      degree: "B.Tech in Environmental Engineering",
      verified: true
    },
    content: "🚀 Milestone achieved! GreenTech Solutions has just closed our Series C funding round, raising $150 million at a $1 billion valuation. This investment will fuel our mission to make sustainable energy accessible to 100 million households across South Asia by 2030. Grateful for our amazing team, visionary investors, and supportive alumni network. Together, we're powering a greener future! 🌿💡 #CleanEnergy #Unicorn #SustainableFuture",
    image: "https://picsum.photos/seed/green1/800/600",
    timestamp: "1 day ago",
    likes: 8200,
    comments: 745,
    shares: 2789,
    type: 'milestone',
    tags: ['#CleanEnergy', '#Startup', '#Impact', '#Sustainability'],
    engagement: {
      topComment: {
        author: "Ratan Tata",
        content: "Congratulations, Arjun! Your journey is an inspiration to young entrepreneurs everywhere."
      }
    }
  },
  {
    id: 3,
    author: {
      name: "Ananya Desai",
      avatar: "https://i.pravatar.cc/150?img=3",
      company: "Flipkart",
      role: "VP of Product",
      graduationYear: 2010,
      degree: "MBA in Technology Management",
      verified: true
    },
    content: "Exciting times at Flipkart! 🎉 We've just rolled out our new AI-powered recommendation engine, and the results are mind-blowing:\n\n📈 45% increase in user engagement\n🛒 30% boost in average order value\n😊 92% customer satisfaction rate\n\nProud of what our cross-functional team has accomplished. This is a game-changer for e-commerce in India! #AI #ECommerce #ProductManagement #TechInnovation",
    videoUrl: "https://example.com/flipkart-ai-demo.mp4",
    timestamp: "5 hours ago",
    likes: 6105,
    comments: 432,
    shares: 1573,
    type: 'product_launch',
    tags: ['#AI', '#ECommerce', '#Innovation', '#TechInIndia'],
    engagement: {
      topComment: {
        author: "Sachin Bansal",
        content: "Phenomenal work, Ananya! This is the kind of innovation that keeps Flipkart at the forefront of Indian e-commerce."
      }
    }
  },
  {
    id: 4,
    author: {
      name: "Dr. Rahul Mehta",
      avatar: "https://i.pravatar.cc/150?img=4",
      company: "Microsoft",
      role: "Principal Architect - Azure Security",
      graduationYear: 2008,
      degree: "M.Tech in Information Security",
      verified: true
    },
    content: "Just published my comprehensive analysis on the future of cloud security. In this article, I dive deep into:\n\n🔒 Zero-Trust Architecture in multi-cloud environments\n🤖 AI-driven threat detection and response\n🌐 Quantum-resistant cryptography\n🔗 Blockchain for secure cloud data management\n\nRead, share, and let's discuss the future of keeping our digital assets safe! #CloudSecurity #Cybersecurity #TechTrends",
    link: {
      url: "https://techinsights.com/future-of-cloud-security-2025",
      title: "The Future of Cloud Security: Emerging Trends and Technologies for 2025 and Beyond",
      description: "An in-depth analysis of upcoming paradigm shifts in cloud security, including AI, quantum computing, and decentralized systems.",
      image: "https://picsum.photos/seed/security1/800/400"
    },
    timestamp: "1 day ago",
    likes: 4900,
    comments: 378,
    shares: 1412,
    type: 'article',
    tags: ['#CloudComputing', '#Cybersecurity', '#FutureTech', '#QuantumComputing'],
    engagement: {
      topComment: {
        author: "Satya Nadella",
        content: "Insightful analysis, Rahul. Your expertise continues to drive our security strategies at Microsoft."
      }
    }
  },
  {
    id: 5,
    author: {
      name: "Neha Gupta",
      avatar: "https://i.pravatar.cc/150?img=5",
      company: "Zomato",
      role: "Chief Data Scientist",
      graduationYear: 2013,
      degree: "B.Tech in Computer Science",
      verified: true
    },
    content: "Absolutely thrilled and humbled to receive the 'Tech Innovator of the Year' award at the Women in Tech Summit 2024! 🏆👩‍💻\n\nThis recognition belongs to my incredible team at Zomato and every woman pushing boundaries in tech. Together, we've revolutionized food delivery logistics using AI, reducing delivery times by 35% and increasing customer satisfaction to 98%.\n\nTo every girl dreaming of a career in tech: the future is yours to shape. Dream big, work hard, and never let anyone tell you it's not possible! 💪🚀 #WomenInTech #AIInnovation #DiversityInTech",
    image: "https://picsum.photos/seed/award1/800/600",
    timestamp: "3 hours ago",
    likes: 10987,
    comments: 1256,
    shares: 3302,
    type: 'award',
    tags: ['#WomenInTech', '#AI', '#Innovation', '#Inspiration'],
    engagement: {
      topComment: {
        author: "Falguni Nayar",
        content: "Congratulations, Neha! Your work is breaking barriers and inspiring the next generation of women in tech. Keep soaring!"
      }
    }
  },
  {
    id: 6,
    author: {
      name: "Vikram Iyer",
      avatar: "https://i.pravatar.cc/150?img=15",
      company: "SpaceX",
      role: "Senior Propulsion Engineer",
      graduationYear: 2016,
      degree: "M.S. in Aerospace Engineering",
      verified: true
    },
    content: "Just witnessed history! 🚀🌟 Our team at SpaceX successfully launched and landed the first fully reusable rocket on Mars. This milestone opens up unprecedented possibilities for interplanetary exploration and colonization. Feeling grateful to be part of this incredible journey. The future of space travel is here! #SpaceExploration #Mars #Engineering #Innovation",
    image: "https://picsum.photos/seed/space1/800/600",
    timestamp: "6 hours ago",
    likes: 15720,
    comments: 2890,
    shares: 7468,
    type: 'achievement',
    tags: ['#SpaceExploration', '#Mars', '#Innovation', '#FutureTech'],
    engagement: {
      topComment: {
        author: "Sundar Pichai",
        content: "This is an incredible achievement, Vikram! The implications for humanity are profound. Congratulations to you and the entire SpaceX team."
      }
    }
  },
  {
    id: 7,
    author: {
      name: "Priyanka Chopra Jonas",
      avatar: "https://i.pravatar.cc/150?img=20",
      company: "UNICEF",
      role: "Goodwill Ambassador",
      graduationYear: 2000,
      degree: "B.A. in Psychology",
      verified: true
    },
    content: "Education is the greatest equalizer and the key to a better future for all children. 📚🌍 Today, I'm proud to announce the launch of the 'Global Education Initiative' in partnership with UNICEF. Our goal is to provide quality education to 1 million underprivileged children across South Asia by 2025.\n\nJoin us in this mission to empower the next generation! Together, we can break the cycle of poverty and create a brighter future for all. #EducationForAll #UNICEF #GlobalCitizen",
    image: "https://picsum.photos/seed/education1/800/600",
    timestamp: "1 day ago",
    likes: 89500,
    comments: 12560,
    shares: 45302,
    type: 'initiative',
    tags: ['#Education', '#UNICEF', '#SocialImpact', '#GlobalCitizen'],
    engagement: {
      topComment: {
        author: "Malala Yousafzai",
        content: "This is wonderful, Priyanka! Education has the power to change lives. Count me in to support this incredible initiative."
      }
    }
  },
  // Add more posts here...
];

// Enhanced mock data for trending topics
const trendingTopics = [
  { tag: "#AIInnovation", count: 15240 },
  { tag: "#StartupIndia", count: 12750 },
  { tag: "#WomenInTech", count: 10890 },
  { tag: "#SustainableTech", count: 9870 },
  { tag: "#SpaceExploration", count: 8960 },
  { tag: "#QuantumComputing", count: 7650 },
  { tag: "#FintechRevolution", count: 6540 },
  { tag: "#HealthTechInnovation", count: 5430 },
  { tag: "#EdTechDisruption", count: 4320 },
  { tag: "#CyberSecurityTrends", count: 3210 }
];

// Enhanced mock data for upcoming events
const upcomingEvents = [
  {
    id: 1,
    title: "Global Alumni Tech Summit 2024",
    date: "Sep 15-17, 2024",
    location: "Bangalore International Convention Center",
    description: "Join tech leaders from around the world for three days of cutting-edge discussions, workshops, and networking opportunities.",
    attendees: 5000,
    speakers: ["Sundar Pichai", "Satya Nadella", "Falguni Nayar"],
    image: "https://picsum.photos/seed/event1/400/300"
  },
  {
    id: 2,
    title: "AI Ethics and Governance Symposium",
    date: "Oct 5-6, 2024",
    location: "Virtual Event",
    description: "Explore the ethical implications of AI and help shape the future of AI governance in this interactive online symposium.",
    attendees: 10000,
    speakers: ["Dr. Priya Sharma", "Elon Musk", "Dr. Rahul Mehta"],
    image: "https://picsum.photos/seed/event2/400/300"
  },
  {
    id: 3,
    title: "Startup Funding Masterclass",
    date: "Nov 20, 2024",
    location: "Mumbai Startup Hub",
    description: "Learn the ins and outs of startup funding from successful entrepreneurs and top-tier VCs in this intensive one-day workshop.",
    attendees: 500,
    speakers: ["Arjun Patel", "Kunal Shah", "Vijay Shekhar Sharma"],
    image: "https://picsum.photos/seed/event3/400/300"
  },
  {
    id: 4,
    title: "Women in STEM Leadership Conference",
    date: "Dec 8-9, 2024",
    location: "Hyderabad Tech Park",
    description: "Empowering women in STEM fields through inspiring keynotes, skill-building workshops, and mentorship opportunities.",
    attendees: 2000,
    speakers: ["Neha Gupta", "Kiran Mazumdar-Shaw", "Debjani Ghosh"],
    image: "https://picsum.photos/seed/event4/400/300"
  }
];

// Mock data for job opportunities
const jobOpportunities = [
  {
    id: 1,
    company: "Google",
    role: "Senior Machine Learning Engineer",
    location: "Bangalore, India",
    salary: "$120,000 - $180,000",
    postedBy: "Dr. Priya Sharma",
    logo: "https://logo.clearbit.com/google.com"
  },
  {
    id: 2,
    company: "Microsoft",
    role: "Principal Cloud Security Architect",
    location: "Hyderabad, India",
    salary: "$150,000 - $200,000",
    postedBy: "Dr. Rahul Mehta",
    logo: "https://logo.clearbit.com/microsoft.com"
  },
  {
    id: 3,
    company: "Zomato",
    role: "Lead Data Scientist",
    location: "Gurgaon, India",
    salary: "₹40,00,000 - ₹60,00,000",
    postedBy: "Neha Gupta",
    logo: "https://logo.clearbit.com/zomato.com"
  },
  {
    id: 4,
    company: "SpaceX",
    role: "Aerospace Engineer - Propulsion Systems",
    location: "Hawthorne, CA, USA",
    salary: "$130,000 - $180,000",
    postedBy: "Vikram Iyer",
    logo: "https://logo.clearbit.com/spacex.com"
  },
  {
    id: 5,
    company: "UNICEF",
    role: "Education Program Manager",
    location: "New Delhi, India",
    salary: "$80,000 - $100,000",
    postedBy: "Priyanka Chopra Jonas",
    logo: "https://logo.clearbit.com/unicef.org"
  }
];

const AlumniSocialShowcase = () => {
  const [selectedPost, setSelectedPost] = useState(null);
  const [filter, setFilter] = useState('all');
  const [sortBy, setSortBy] = useState('recent');
  const [searchTerm, setSearchTerm] = useState('');
  const [showNewPostModal, setShowNewPostModal] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const filteredPosts = alumniPosts.filter(post => {
    if (filter === 'all') return true;
    return post.type === filter;
  }).filter(post =>
    post.author.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    post.content.toLowerCase().includes(searchTerm.toLowerCase()) ||
    post.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const sortedPosts = [...filteredPosts].sort((a, b) => {
    if (sortBy === 'recent') return new Date(b.timestamp) - new Date(a.timestamp);
    if (sortBy === 'popular') return b.likes - a.likes;
    return 0;
  });

  useEffect(() => {
    // Simulating real-time notifications
    const notificationInterval = setInterval(() => {
      const newNotification = {
        id: Date.now(),
        content: `New post from ${alumniPosts[Math.floor(Math.random() * alumniPosts.length)].author.name}`,
        timestamp: new Date().toISOString()
      };
      setNotifications(prev => [newNotification, ...prev.slice(0, 4)]);
    }, 30000);

    return () => clearInterval(notificationInterval);
  }, []);

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="bg-white shadow-md sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
        <div className="flex items-center space-x-2 text-2xl font-bold tracking-tight text-indigo-600 hover:text-indigo-700 transition-colors" >
            <FaAward className="text-3xl" />
            <span>MANZIL</span>
          </div>
          <div className="flex items-center space-x-4">
            <div className="relative">
              <input
                type="text"
                placeholder="Search..."
                className="pl-10 pr-4 py-2 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            </div>
            <button 
              className="bg-blue-500 text-white px-4 py-2 rounded-full hover:bg-blue-600 transition duration-300"
              onClick={() => setShowNewPostModal(true)}
            >
              New Post
            </button>
            <div className="relative">
              <FaBell className="text-gray-600 text-xl cursor-pointer" />
              {notifications.length > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
                  {notifications.length}
                </span>
              )}
            </div>
            <img src="https://i.pravatar.cc/150?img=68" alt="User Avatar" className="w-10 h-10 rounded-full" />
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col lg:flex-row">
          {/* Left Sidebar */}
          <div className="w-full lg:w-1/4 mb-8 lg:mb-0 lg:mr-8">
            <ProfileCard />
            <FilterCard filter={filter} setFilter={setFilter} />
            <TrendingTopicsCard topics={trendingTopics} />
          </div>

          {/* Main Content */}
          <div className="w-full lg:w-1/2">
            <SortOptions sortBy={sortBy} setSortBy={setSortBy} />
            <NewPostCard setShowNewPostModal={setShowNewPostModal} />
            <PostList posts={sortedPosts} />
          </div>

          {/* Right Sidebar */}
          <div className="w-full lg:w-1/4 mt-8 lg:mt-0 lg:ml-8">
          <EnhancedAIAlumniInsights />
            <UpcomingEventsCard events={upcomingEvents} />
            <JobOpportunitiesCard jobs={jobOpportunities} />
            <AlumniSpotlightCard />
          </div>
        </div>
      </main>

     

      {/* New Post Modal */}
      <NewPostModal showModal={showNewPostModal} setShowModal={setShowNewPostModal} />

      {/* Notification Toast */}
      <NotificationToast notifications={notifications} />
    </div>
  );
};

const EnhancedAIAlumniInsights = () => {
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [insights, setInsights] = useState(null);

  const generateInsights = () => {
    setIsAnalyzing(true);
    setTimeout(() => {
      setInsights({
        careerTrajectory: {
          nextRole: "Chief Innovation Officer",
          timeLine: "2-3 years",
          keySkills: ["AI Ethics", "Strategic Foresight", "Cross-functional Leadership"]
        },
        networkSuggestions: [
          { name: "Dr. Priya Sharma", role: "AI Research Lead at DeepMind", commonInterests: ["Quantum Computing", "Climate Tech"] },
          { name: "Vikram Iyer", role: "Senior Engineer at SpaceX", commonInterests: ["Aerospace Innovation", "Sustainable Tech"] }
        ],
        trendingTopics: ["Green AI", "Space Tourism Ethics", "Quantum Machine Learning"],
        personalisedOpportunities: [
          { type: "Speaking", event: "TechInnovate 2025", topic: "AI in Sustainable Development" },
          { type: "Mentorship", program: "Women in STEM Leadership", focus: "AI Career Guidance" }
        ]
      });
      setIsAnalyzing(false);
    }, 3000);
  };

  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-100 rounded-xl shadow-2xl p-8 max-w-6xl mx-auto">
      <h2 className="text-3xl font-bold mb-6 text-center text-indigo-800">AI-Powered Alumni Insights</h2>
      
      {!insights && !isAnalyzing && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center py-20"
        >
          <FaBrain className="text-8xl text-indigo-500 mb-6 mx-auto" />
          <h3 className="text-2xl font-semibold mb-4 text-gray-800">Discover Your Personalized Insights</h3>
          <p className="text-gray-600 mb-8">Let our AI analyze your profile and unlock tailored opportunities.</p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-indigo-600 text-white py-3 px-8 rounded-full font-semibold text-lg shadow-lg hover:bg-indigo-700 transition duration-300"
            onClick={generateInsights}
          >
            Generate AI Insights
          </motion.button>
        </motion.div>
      )}

      {isAnalyzing && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="flex flex-col items-center justify-center py-20"
        >
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 2, loop: Infinity, ease: "linear" }}
            className="mb-6"
          >
            <FaBrain className="text-8xl text-indigo-500" />
          </motion.div>
          <h3 className="text-2xl font-semibold mb-2 text-gray-800">Analyzing Your Profile</h3>
          <p className="text-gray-600">Our AI is processing your data to generate personalized insights...</p>
        </motion.div>
      )}

      {insights && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-8"
        >
          <InsightCard
            title="Career Trajectory"
            icon={FaRocket}
            content={
              <div className="space-y-4">
                <div className="flex items-center">
                  <div className="flex-shrink-0 h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center">
                    <FaUserGraduate className="text-blue-600" />
                  </div>
                  <div className="ml-4">
                    <p className="text-sm font-medium text-gray-900">Next Potential Role</p>
                    <p className="text-lg font-semibold text-indigo-600">{insights.careerTrajectory.nextRole}</p>
                  </div>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-900">Estimated Timeline</p>
                  <p className="text-lg font-semibold text-indigo-600">{insights.careerTrajectory.timeLine}</p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-900 mb-2">Key Skills to Develop</p>
                  <div className="flex flex-wrap gap-2">
                    {insights.careerTrajectory.keySkills.map((skill, index) => (
                      <span key={index} className="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded">
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            }
          />
          <InsightCard
            title="Network Expansion"
            icon={FaNetworkWired}
            content={
              <div className="space-y-4">
                {insights.networkSuggestions.map((suggestion, index) => (
                  <div key={index} className="flex items-center">
                    <img src={`https://i.pravatar.cc/60?img=${index + 1}`} alt={suggestion.name} className="w-10 h-10 rounded-full" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-gray-900">{suggestion.name}</p>
                      <p className="text-xs text-gray-500">{suggestion.role}</p>
                      <div className="flex flex-wrap gap-1 mt-1">
                        {suggestion.commonInterests.map((interest, i) => (
                          <span key={i} className="bg-green-100 text-green-800 text-xs px-2 py-0.5 rounded">
                            {interest}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            }
          />
          <InsightCard
            title="Trending Topics"
            icon={FaChartLine}
            content={
              <div className="space-y-4">
                {insights.trendingTopics.map((topic, index) => (
                  <div key={index} className="flex items-center">
                    <div className="flex-shrink-0 h-8 w-8 bg-purple-100 rounded-full flex items-center justify-center">
                      <span className="text-purple-600 font-semibold">{index + 1}</span>
                    </div>
                    <p className="ml-4 text-gray-800">{topic}</p>
                  </div>
                ))}
              </div>
            }
          />
          <InsightCard
            title="Personalized Opportunities"
            icon={FaLightbulb}
            content={
              <div className="space-y-4">
                {insights.personalisedOpportunities.map((opportunity, index) => (
                  <div key={index} className="bg-yellow-50 p-4 rounded-lg">
                    <p className="text-sm font-medium text-yellow-800">{opportunity.type}</p>
                    <p className="text-lg font-semibold text-gray-900">{opportunity.event || opportunity.program}</p>
                    <p className="text-sm text-gray-600">{opportunity.topic || opportunity.focus}</p>
                    <button className="mt-2 text-yellow-600 hover:text-yellow-700 font-medium flex items-center">
                      Learn More <FaArrowRight className="ml-1" />
                    </button>
                  </div>
                ))}
              </div>
            }
          />
        </motion.div>
      )}

      {insights && (
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="mt-8 bg-indigo-600 text-white py-3 px-8 rounded-full font-semibold text-lg shadow-lg hover:bg-indigo-700 transition duration-300 mx-auto block"
          onClick={() => setInsights(null)}
        >
          Refresh Insights
        </motion.button>
      )}
    </div>
  );
};

const InsightCard = ({ title, icon: Icon, content }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition duration-300"
  >
    <div className="flex items-center mb-4">
      <Icon className="text-indigo-500 mr-3 text-2xl" />
      <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
    </div>
    <div>{content}</div>
  </motion.div>
);



// Helper components

const ProfileCard = () => (
  <div className="bg-white rounded-lg shadow-md p-6 mb-6">
    <div className="flex items-center mb-4">
      <img src="https://i.pravatar.cc/150?img=68" alt="Your Avatar" className="w-16 h-16 rounded-full mr-4" />
      <div>
        <h2 className="text-xl font-semibold">Dr. Aisha Patel</h2>
        <p className="text-gray-600">AI Researcher @ DeepMind</p>
      </div>
    </div>
    <div className="flex justify-between text-sm text-gray-600 mb-4">
      <span>500+ connections</span>
      <span>50 mutual connections</span>
    </div>
    <button className="w-full bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition duration-300">
      View Profile
    </button>
  </div>
);

const FilterCard = ({ filter, setFilter }) => (
  <div className="bg-white rounded-lg shadow-md p-6 mb-6">
    <h2 className="text-xl font-semibold mb-4">Filters</h2>
    <div className="space-y-2">
      <FilterButton label="All Posts" value="all" currentFilter={filter} setFilter={setFilter} icon={FaGlobe} />
      <FilterButton label="Achievements" value="achievement" currentFilter={filter} setFilter={setFilter} icon={FaAward} />
      <FilterButton label="Milestones" value="milestone" currentFilter={filter} setFilter={setFilter} icon={FaFlag} />
      <FilterButton label="Product Launches" value="product_launch" currentFilter={filter} setFilter={setFilter} icon={FaRocket} />
      <FilterButton label="Articles" value="article" currentFilter={filter} setFilter={setFilter} icon={FaNewspaper} />
      <FilterButton label="Initiatives" value="initiative" currentFilter={filter} setFilter={setFilter} icon={FaHandshake} />
    </div>
  </div>
);

const FilterButton = ({ label, value, currentFilter, setFilter, icon: Icon }) => (
  <button 
    onClick={() => setFilter(value)}
    className={`w-full flex items-center text-left px-4 py-2 rounded-md ${currentFilter === value ? 'bg-blue-100 text-blue-600' : 'hover:bg-gray-100'}`}
  >
    <Icon className="mr-2" />
    {label}
  </button>
);

const TrendingTopicsCard = ({ topics }) => (
  <div className="bg-white rounded-lg shadow-md p-6">
    <h2 className="text-xl font-semibold mb-4">Trending Topics</h2>
    <div className="space-y-2">
      {topics.map((topic, index) => (
        <div key={index} className="flex justify-between items-center">
          <span className="text-blue-500 hover:underline cursor-pointer">{topic.tag}</span>
          <span className="text-gray-500 text-sm">{topic.count} posts</span>
        </div>
      ))}
    </div>
  </div>
);

const SortOptions = ({ sortBy, setSortBy }) => (
  <div className="mb-6 flex justify-end">
    <select 
      className="p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      value={sortBy}
      onChange={(e) => setSortBy(e.target.value)}
    >
      <option value="recent">Most Recent</option>
      <option value="popular">Most Popular</option>
    </select>
  </div>
);

const NewPostCard = ({ setShowNewPostModal }) => (
  <div className="bg-white rounded-lg shadow-md p-6 mb-6">
    <div className="flex items-center">
      <img src="https://i.pravatar.cc/150?img=68" alt="Your Avatar" className="w-12 h-12 rounded-full mr-4" />
      <button 
        className="w-full text-left text-gray-500 bg-gray-100 px-4 py-2 rounded-full hover:bg-gray-200 transition duration-300"
        onClick={() => setShowNewPostModal(true)}
      >
        What's on your mind?
      </button>
    </div>
    <div className="flex justify-between mt-4">
      <button className="flex items-center text-gray-600 hover:text-blue-500">
        <FaCamera className="mr-2" /> Photo
      </button>
      <button className="flex items-center text-gray-600 hover:text-blue-500">
        <FaVideo className="mr-2" /> Video
      </button>
      <button className="flex items-center text-gray-600 hover:text-blue-500">
        <FaNewspaper className="mr-2" /> Article
      </button>
      <button className="flex items-center text-gray-600 hover:text-blue-500">
        <FaPoll className="mr-2" /> Poll
      </button>
    </div>
  </div>
);

const PostList = ({ posts }) => (
  <div className="space-y-6">
    {posts.map(post => (
      <PostCard key={post.id} post={post} />
    ))}
  </div>
);

const PostCard = ({ post }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    className="bg-white rounded-lg shadow-md overflow-hidden"
  >
    <div className="p-6">
      <div className="flex items-center mb-4">
        <img src={post.author.avatar} alt={post.author.name} className="w-12 h-12 rounded-full mr-4" />
        <div>
          <div className="flex items-center">
            <h3 className="font-semibold mr-2">{post.author.name}</h3>
            {post.author.verified && <FaCheckCircle className="text-blue-500" />}
          </div>
          <p className="text-gray-600 text-sm">{post.author.role} at {post.author.company}</p>
          <p className="text-gray-500 text-xs">{post.timestamp} • {post.author.graduationYear} graduate</p>
        </div>
      </div>
      <p className="text-gray-800 mb-4 whitespace-pre-wrap">{post.content}</p>
      {post.image && (
        <img src={post.image} alt="Post content" className="w-full h-auto object-cover mb-4 rounded-md" />
      )}
      {post.videoUrl && (
        <video src={post.videoUrl} controls className="w-full h-auto mb-4 rounded-md" />
      )}
      {post.link && (
        <a href={post.link.url} target="_blank" rel="noopener noreferrer" className="block bg-gray-100 p-4 rounded-md hover:bg-gray-200 transition duration-300 mb-4">
          <h4 className="font-semibold text-blue-600">{post.link.title}</h4>
          <p className="text-gray-600 text-sm">{post.link.description}</p>
          <p className="text-gray-500 text-xs truncate">{post.link.url}</p>
        </a>
      )}
      <div className="flex flex-wrap gap-2 mb-4">
        {post.tags.map((tag, index) => (
          <span key={index} className="bg-blue-100 text-blue-600 px-2 py-1 rounded-full text-sm">
            {tag}
          </span>
        ))}
      </div>
      <div className="flex justify-between items-center mt-4 text-gray-600">
        <div className="flex space-x-4">
          <button className="flex items-center space-x-1 hover:text-blue-500">
            <FaHeart /> <span>{post.likes}</span>
          </button>
          <button className="flex items-center space-x-1 hover:text-blue-500">
            <FaComment /> <span>{post.comments}</span>
          </button>
          <button className="flex items-center space-x-1 hover:text-blue-500">
            <FaShare /> <span>{post.shares}</span>
          </button>
        </div>
        <button className="hover:text-blue-500">
          <FaBookmark />
        </button>
      </div>
      {post.engagement && post.engagement.topComment && (
        <div className="mt-4 bg-gray-50 p-3 rounded-md">
          <p className="font-semibold text-sm">{post.engagement.topComment.author}</p>
          <p className="text-gray-600 text-sm">{post.engagement.topComment.content}</p>
        </div>
      )}
    </div>
  </motion.div>
);

const UpcomingEventsCard = ({ events }) => (
  <div className="bg-white rounded-lg shadow-md p-6 mb-6">
    <h2 className="text-xl font-semibold mb-4">Upcoming Events</h2>
    <div className="space-y-4">
      {events.map(event => (
        <div key={event.id} className="border-b pb-4 last:border-b-0">
          <img src={event.image} alt={event.title} className="w-full h-40 object-cover rounded-md mb-2" />
          <h3 className="font-semibold">{event.title}</h3>
          <p className="text-gray-600 text-sm">{event.date}</p>
          <p className="text-gray-600 text-sm">{event.location}</p>
          <p className="text-gray-600 text-sm mt-2">{event.attendees} attendees</p>
          <div className="flex items-center mt-2">
            <FaUser className="text-gray-400 mr-2" />
            <p className="text-gray-600 text-sm">{event.speakers.join(', ')}</p>
          </div>
        </div>
      ))}
    </div>
    <button className="w-full mt-4 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition duration-300">
      View All Events
    </button>
  </div>
);

const JobOpportunitiesCard = ({ jobs }) => (
  <div className="bg-white rounded-lg shadow-md p-6 mb-6">
    <h2 className="text-xl font-semibold mb-4">Job Opportunities</h2>
    <div className="space-y-4">
      {jobs.map(job => (
        <div key={job.id} className="flex items-center border-b pb-4 last:border-b-0">
          <img src={job.logo} alt={job.company} className="w-12 h-12 object-contain mr-4" />
          <div>
            <h3 className="font-semibold">{job.role}</h3>
            <p className="text-gray-600 text-sm">{job.company}</p>
            <p className="text-gray-600 text-sm">{job.location}</p>
            <p className="text-gray-600 text-sm">{job.salary}</p>
          </div>
        </div>
      ))}
    </div>
    <button className="w-full mt-4 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition duration-300">
      View All Jobs
    </button>
  </div>
);

const AlumniSpotlightCard = () => (
  <div className="bg-white rounded-lg shadow-md p-6">
    <h2 className="text-xl font-semibold mb-4">Alumni Spotlight</h2>
    <div className="text-center">
      <img src="https://i.pravatar.cc/150?img=68" alt="Featured Alumni" className="w-24 h-24 rounded-full mx-auto mb-4" />
      <h3 className="font-semibold">Dr. Vikram Patel</h3>
      <p className="text-gray-600 text-sm">AI Ethics Researcher, MIT</p>
      <p className="text-gray-600 text-sm mt-2">Class of 2010</p>
      <p className="text-gray-600 text-sm mt-2">
        "Our education prepared us not just for jobs, but to be leaders in innovation and social impact."
      </p>
      <button className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-full hover:bg-blue-600 transition duration-300">
        Read Full Story
      </button>
    </div>
  </div>
);



const NewPostModal = ({ showModal, setShowModal }) => (
  <AnimatePresence>
    {showModal && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
      >
        <motion.div
          initial={{ scale: 0.9 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0.9 }}
          className="bg-white rounded-lg p-8 max-w-2xl w-full"
        >
          <h2 className="text-2xl font-bold mb-4">Create New Post</h2>
          <textarea
            className="w-full h-32 p-2 border rounded-md mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="What's on your mind?"
          ></textarea>
          <div className="flex justify-between mb-4">
            <button className="flex items-center space-x-2 text-gray-600 hover:text-blue-500">
              <FaCamera />
              <span>Photo</span>
            </button>
            <button className="flex items-center space-x-2 text-gray-600 hover:text-blue-500">
              <FaVideo />
              <span>Video</span>
            </button>
            <button className="flex items-center space-x-2 text-gray-600 hover:text-blue-500">
              <FaPoll />
              <span>Poll</span>
            </button>
            <button className="flex items-center space-x-2 text-gray-600 hover:text-blue-500">
              <FaLink />
              <span>Link</span>
            </button>
          </div>
          <div className="flex justify-end">
            <button 
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md mr-2 hover:bg-gray-400 transition duration-300"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
            <button className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition duration-300">
              Post
            </button>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

const NotificationToast = ({ notifications }) => (
  <div className="fixed bottom-4 right-4 space-y-2">
    <AnimatePresence>
      {notifications.map((notification) => (
        <motion.div
          key={notification.id}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          className="bg-white text-gray-800 px-4 py-2 rounded-md shadow-lg flex items-center"
        >
          <FaBell className="text-blue-500 mr-2" />
          <span>{notification.content}</span>
        </motion.div>
      ))}
    </AnimatePresence>
  </div>
);

export default AlumniSocialShowcase;